<script>
/**
 * Advanced table component
 */
export default {
  data() {
    return {
      user: null,
      filterDays: 1,
      filterPeriod: 'روزانه',
      date: 'week',
      incomeData: '',
      spentData: '',
      series: [
        {
          name: 'ورودی',
          data: [],
        },
        {
          name: 'خروجی',
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: true,
            easing: 'linear',
            dynamicAnimation: {
              speed: 1000,
            },
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        colors: ['#7deea3', '#ee7d7d'],
        xaxis: {
          categories: [],
        },
        tooltip: {
          y: {
            formatter: function(value) {
              let Number = value
              Number += ''
              Number = Number.replace(',', '')
              const x = Number.split('.')
              let y = x[0]
              const z = x.length > 1 ? '.' + x[1] : ''
              const rgx = /(\d+)(\d{3})/
              while (rgx.test(y)) y = y.replace(rgx, '$1' + ',' + '$2')
              return y + z + ' تومان'
            },
          },
        },
      },
    }
  },
  mounted() {
    this.fetchChartData()
  },
  methods: {
    fetchChartData() {
      this.$axios
        .get(`wallet-turnover/chart-data?period=${this.date}`)
        .then((res) => {
          this.chartOptions = {
            ...this.chartOptions,
            ...{
              xaxis: {
                categories: res.data.labels,
              },
            },
          }
          this.series[0].data = res.data.data.entrance
          this.series[1].data = res.data.data.exit
          this.$refs.realtimeChart.updateSeries(this.series, false, true)
        })
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mx-auto justify-content-between align-items-center">
            <h4 class="card-title mb-12">
              نمودار گردش کیف پول
            </h4>
            <div class="d-flex">
              <div class="mr-4">
                <label>دوره زمانی</label>
                <select
                  @change="fetchChartData"
                  v-model="date"
                  class="form-control"
                >
                  <option value="week">هفته جاری</option>
                  <option value="month">ماه جاری</option>
                  <option value="three_month">سه ماه گذشته</option>
                  <option value="six_month">6 ماه گذشته</option>
                  <option value="year">سال گذشته</option>
                </select>
              </div>
            </div>
          </div>
          <div>
            <div class="apex-charts" dir="rtl"></div>
            <apexchart
              class="apex-charts"
              dir="rtl"
              ref="realtimeChart"
              :series="series"
              :options="chartOptions"
              type="line"
              height="350"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
